import { z } from 'zod';

export const InfraImpactSchema = z
  .enum([
    'DOMAIN_COMPROMISE',
    'HOST_COMPROMISE',
    'DOMAIN_USER_COMPROMISE',
    'SENSITIVE_DATA_EXPOSURE',
    'RANSOMWARE_EXPOSURE',
    'CREDENTIAL_EXPOSURE',
    'PRIVILEGE_ESCALATION',
    'LATERAL_MOVEMENT',
  ])
  .describe('Closed infra impact class used for prioritization (not CVSS)');

export const BusinessRiskSchema = z
  .enum([
    'OPERATIONAL_DISRUPTION',
    'CRITICAL_SYSTEM_SHUTDOWN',
    'THEFT_OF_IP',
    'REGULATORY_BREACH',
    'FINANCIAL_LOSS',
    'REPUTATIONAL_DAMAGE',
  ])
  .describe('Closed business-risk class derived from infra impact');

export const INFRA_IMPACT_VALUES = InfraImpactSchema.options;
export const BUSINESS_RISK_VALUES = BusinessRiskSchema.options;

export type InfraImpact = z.infer<typeof InfraImpactSchema>;
export type BusinessRisk = z.infer<typeof BusinessRiskSchema>;

const MILESTONE_INFRA_IMPACTS = new Set<InfraImpact>([
  'DOMAIN_COMPROMISE',
  'HOST_COMPROMISE',
  'DOMAIN_USER_COMPROMISE',
  'SENSITIVE_DATA_EXPOSURE',
  'RANSOMWARE_EXPOSURE',
  'CREDENTIAL_EXPOSURE',
]);

export const isMilestoneInfraImpact = (impact: InfraImpact): boolean =>
  MILESTONE_INFRA_IMPACTS.has(impact);
